module.exports = __webpack_public_path__ + "img/logov1.104250a0.png";